
export default {
	props: {
		remainTime: {
			type: Number,
			// 倒计时间总秒数
			default: ''
		},
		fullTime: {
			default: false,
			type: Boolean
		},
		simple: {
			default: false,
			type: Boolean
		},
		type: {
			type: String,
			default: 'normal',
			validator: val => ['normal', 'text'].includes(val)
		}
	},
	data() {
		return {
			hour: 0,
			minute: 0,
			second: 0,
			promiseTimer: ''
		}
	},

	computed: {
		hourString() {
			return this.formatNum(this.hour)
		},
		minuteString() {
			return this.formatNum(this.minute)
		},
		secondString() {
			return this.formatNum(this.second)
		}
	},
	mounted() {
		if (this.remainTime > 0) {
			this.hour = Math.floor((this.remainTime / 3600) % 24)
			this.minute = Math.floor((this.remainTime / 60) % 60)
			this.second = Math.floor(this.remainTime % 60)
			this.countDowm()
		}
	},
	methods: {
		countDowm() {
			const self = this
			clearInterval(this.promiseTimer)
			this.promiseTimer = setInterval(function () {
				if (self.hour === 0) {
					if (self.minute !== 0 && self.second === 0) {
						self.second = 59
						self.minute -= 1
					} else if (self.minute === 0 && self.second === 0) {
						self.second = 0
						self.$emit('countDowmEnd', true)
						clearInterval(self.promiseTimer)
					} else {
						self.second -= 1
					}
				} else {
					if (self.minute !== 0 && self.second === 0) {
						self.second = 59
						self.minute -= 1
					} else if (self.minute === 0 && self.second === 0) {
						self.hour -= 1
						self.minute = 59
						self.second = 59
					} else {
						self.second -= 1
					}
				}

				self.$emit('update', {
					hour:self.hourString,
					minute:self.minuteString,
					second:self.secondString
				})
			}, 1000)
		},
		formatNum(num) {
			if (this.simple) {
				return num
			}
			return num < 10 ? '0' + num : '' + num
		}
	}
}
